import React, { useEffect, useRef, useState } from "react";
import "./VideoSlider.css";
import GridLoader from "../../../../../ui/loaders/GridLoader/GridLoader";
import LoadingRing from "../../../../../assets/gifs/LoadingRing/LoadingRing";

interface VideoSliderProps {
    source: string;
    initialStartTimestamp: number;
    initialEndTimestamp: number;
    addImage: (dataUrl: string, timestamp: number) => void;
}

const VideoSlider: React.FC<VideoSliderProps> = ({ source, initialStartTimestamp, initialEndTimestamp, addImage }) => {
    const videoRef = useRef<HTMLVideoElement | null>(null);
    const [sliderValue, setSliderValue] = useState(initialStartTimestamp);
    const [videoDuration, setVideoDuration] = useState<number | null>(null);
    const [startTimestamp, setStartTimestamp] = useState(initialStartTimestamp);
    const [endTimestamp, setEndTimestamp] = useState(initialEndTimestamp);
    const [loading, setLoading] = useState(true);
    const [addLoading, setAddLoading] = useState(false)
    useEffect(() => {
        const video = videoRef.current;
        if (!video) return;

        const handleMetadataLoaded = () => {
            console.log("ADDING METADATA", video.duration);
            setVideoDuration(video.duration);
        };

        video.addEventListener("loadedmetadata", handleMetadataLoaded);
        return () => video.removeEventListener("loadedmetadata", handleMetadataLoaded);
    }, []);

    useEffect(() => {
        if (videoDuration !== null) {
            console.log("OLD TIMESTAMPS", initialStartTimestamp, initialEndTimestamp);
            console.log(
                "NEW TIMESTAMPS",
                Math.max(0, Math.min(initialStartTimestamp, videoDuration)),
                Math.max(0, Math.min(initialEndTimestamp, videoDuration))
            );
            setStartTimestamp(Math.max(0, Math.min(initialStartTimestamp, videoDuration)));
            setEndTimestamp(Math.max(0, Math.min(initialEndTimestamp, videoDuration)));
            setLoading(false);
            if (videoRef.current) {
                videoRef.current.currentTime = Math.max(0, Math.min(initialStartTimestamp, videoDuration));
            }
        }
    }, [videoDuration, initialStartTimestamp, initialEndTimestamp]);
    const getScreenshot = () => {
        setAddLoading(true)
        const video = videoRef.current;
        if (!video) return;

        const canvas = document.createElement("canvas");
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const ctx = canvas.getContext("2d");
        if (!ctx) return;

        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        const screenshotDataUrl = canvas.toDataURL();
        addImage(screenshotDataUrl, sliderValue);
    };

    const handleSliderChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        console.log("SLIDER CHANGE", event, startTimestamp, endTimestamp);
        const value = parseFloat(event.target.value);
        setSliderValue(value);
        if (videoRef.current) {
            videoRef.current.currentTime = value;
        }
    };

    const percentage = ((sliderValue - startTimestamp) / (endTimestamp - startTimestamp)) * 100;

// Dynamic linear gradient for the slider's background
    const sliderBackground = `linear-gradient(to right, #d43f8c ${percentage}%, darkgray ${percentage}%, darkgray 100%)`;
    let leftWidth = 0;
    let rightWidth = 0;

    if (videoDuration !== null) {
        leftWidth = (startTimestamp / videoDuration) * 100;
        rightWidth = 100 - (endTimestamp / videoDuration) * 100;
    }
    return (
        <>
            {loading && <GridLoader></GridLoader>}
            <div className="video-slider-container" style={{ visibility: loading ? "hidden" : "visible" }}>
                <div className="video-slider-explanation">
                    Select the screenshot to be added in the transcript. This will be used to sync the audio and video.
                </div>
                <video ref={videoRef} src={source} className="video-slider-video" crossOrigin="anonymous"></video>
                <div className="video-slider-wrapper">
                    <div className="video-slider-inactive" style={{ width: `${leftWidth}%` }}></div>
                    <input
                        type="range"
                        min={startTimestamp}
                        max={endTimestamp}
                        value={sliderValue}
                        step="0.1"
                        onChange={handleSliderChange}
                        className="video-slider-input"
                        style= {{background: sliderBackground}}
                    />
                    <div className="video-slider-inactive" style={{ width: `${rightWidth}%` }}></div>
                </div>
                <button onClick={getScreenshot} className="video-slider-button">
                    
                    <span style= {{display: 'flex'}}>
                    Add 
                            {addLoading ? <LoadingRing color="white" /> : null}
                    </span>
                </button>
            </div>
        </>
    );
};

export default VideoSlider;
